import React from "react"
import { createRoot } from "react-dom/client"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import GameSelector from "./GameSelector"
import { LanguageProvider } from "./LanguageContext"
import { ThemeProvider } from "./ThemeManager"
import AboutPage from "./AboutPage"
import LandingPage from "./LandingPage"
import MissiesPage from "./MissiesPage"
import ResourcesPage from "./ResourcesPage"
import ArticlePage from "./ArticlePage"
import NotFoundPage from "./NotFoundPage"
import AdminApp from "./admin/AdminApp"
   import TeachersPage from "./TeachersPage"
import ChatSetup from "./chat/ChatSetup"; // ✅ add
   import ChatLanding from "./chat/ChatLanding";
import ChatPage from "./chat/ChatPage";



const rootElement = document.getElementById("root")
const root = createRoot(rootElement)

root.render(
  <React.StrictMode>
    <ThemeProvider>
      <LanguageProvider>
        <Router>
          <Routes>
            <Route path="/lessons" element={<GameSelector />} />
            <Route path="/" element={<LandingPage />} />
            <Route path="/missies" element={<MissiesPage onReturnHome={() => (window.location.href = "/")} />} />
            <Route path="/ontdek" element={<ResourcesPage />} />
            <Route path="/ontdek/preview/:id" element={<ArticlePage />} />
            <Route path="/ontdek/:slug" element={<ArticlePage />} />
            <Route path="/beta" element={<GameSelector />} />
            <Route path="/about" element={<AboutPage onReturnHome={() => (window.location.href = "/")} />} />
            <Route path="/lesson-admin" element={<AdminApp />} />
            <Route path="/portal/lesson-admin" element={<AdminApp />} />
            <Route path="/portal/lesson-admin/" element={<AdminApp />} />
               <Route path="/teachers" element={<TeachersPage onReturnHome={() => (window.location.href = "/")} />} />
<Route path="/chat" element={<ChatLanding />} />
<Route path="/chat/setup" element={<ChatSetup />} />  {/* ✅ add */}

<Route path="/chat/play" element={<ChatPage />} />

            <Route path="*" element={<NotFoundPage />} />

          </Routes>
        </Router>
      </LanguageProvider>
    </ThemeProvider>
  </React.StrictMode>,
)
